import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { setupGlobalErrorHandlers } from './utils/globalErrorHandler';
import { captureAttribution } from './utils/attribution';
import './index.css';

/*
 * utils/globalErrorHandler has always had these listeners; nothing installed
 * them, so an unhandled rejection or an uncaught error went straight to the
 * browser console unlogged and unsanitised.
 */
setupGlobalErrorHandlers();

/*
 * The landing URL's campaign, recorded before React renders. The route-change
 * effect in App records it too, but effects run after the first paint -- a
 * visitor who clicked away that quickly lost the ad click, which the e2e spec
 * caught intermittently. Staff on the admin portal are not a campaign.
 */
if (!window.location.pathname.startsWith('/admin-qa-management-portal')) {
  captureAttribution(window.location.href, document.referrer);
}

createRoot(document.getElementById('root')!).render(<App />);
